export default __webpack_public_path__ + "static/media/h-portfolio-locafacil.dd707edd.webp";